import {HttpResponse} from "@/app/api/request";
import {IotGateModel} from "@/app/models/iot-gate.model";
import {api} from "@/app/api";
import {IotGateModelWithSpamPrevention} from "@/app/models/iot-gate-model-with-spam-protection.model";
import {Ref, ref} from "@vue/composition-api";


export const useIoTControl = () => {

    // Gates per facility
    const gates: Ref<IotGateModelWithSpamPrevention[]> = ref([])

    // Status is composable dependant
    const isOpenGatePending = ref(false)

    async function fetchGatesWithSpamPrevention(facilityId: string): Promise<Ref<IotGateModelWithSpamPrevention[]>> {

        // Reset the gates
        gates.value = []

        const response: HttpResponse<IotGateModel[]> = await api.findAllGatesForFacility(
            facilityId,
        )

        if (response.wasSuccessful && response.data) {
            response.data.forEach(iotGate => {
                (iotGate as IotGateModelWithSpamPrevention).spamPrevention = false;
                (iotGate as IotGateModelWithSpamPrevention).opening = false;
                gates.value.push(iotGate as IotGateModelWithSpamPrevention)
            })
        }

        return gates
    }

    async function openGate(
        bookingId: string,
        gateId: number,
    ) {
        isOpenGatePending.value = true
        const response = await api.openGateByBooking(
            bookingId,
            gateId,
        )
        isOpenGatePending.value = false
        return response
    }

    async function openMainGate(bookingId: string) {
        if (gates.value.length > 0) {
            const mainGate = gates.value.find((gate => gate.gateId === 1))

            if (mainGate) {
                await openGate(bookingId, mainGate.gateId)
            }
        }
    }

    return {
        // Variables
        gates,
        isOpenGatePending,

        // Methods
        fetchGatesWithSpamPrevention,
        openGate,
        openMainGate,
    }
}
